// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__xYrpW","subtitle":"Projects_subtitle__GDeIn"};